const asset = (path) => `${process.env.PUBLIC_URL || ""}${path}`;

const LOGO_FILES = {
  main: "/assets/logos/iyaf-main.png",
  hub: "/assets/logos/iyaf-hub.png",
  social: "/assets/logos/iyaf-social.png",
  consult: "/assets/logos/iyaf-consult.png",
  venture: "/assets/logos/iyaf-venture.png",
  mark: "/assets/logos/iyaf-mark.png",
  mono: "/assets/logos/iyaf-mono.png",
};

/**
 * IyafWordmark — renders the ACTUAL IYAF logo PNG (no recreation).
 * Variants pick the correct official asset for each arm/state.
 */
export function IyafWordmark({
  variant = "main",   // 'main' | 'hub' | 'social' | 'consult' | 'venture' | 'mono'
  size = "md",        // 'sm' | 'md' | 'lg' | 'xl' | 'hero'
  className = "",
  inverse = false,
}) {
  const heights = {
    sm: "h-7 sm:h-8",
    md: "h-10 sm:h-12",
    lg: "h-14 sm:h-16",
    xl: "h-20 sm:h-24",
    hero: "h-24 sm:h-32 lg:h-40",
  };

  const key = inverse ? "mono" : variant in LOGO_FILES ? variant : "main";
  const src = asset(LOGO_FILES[key] || LOGO_FILES.main);
  const h = heights[size] || heights.md;

  return (
    <img
      src={src}
      alt={variant === "main" ? "IYAF" : `IYAF ${variant}`}
      className={`${h} w-auto select-none ${inverse ? "brightness-0 invert" : ""} ${className}`}
      style={{ objectFit: "contain" }}
      draggable={false}
    />
  );
}

/** Small monogram for favicon-size spaces — uses the icon-only PNG */
export function IyafMonogram({ className = "h-9 w-auto", inverse = false }) {
  return <IyafWordmark variant="mark" size="md" inverse={inverse} className={className} />;
}

/** Sub-arm concentric circles glyph (decorative) */
export function ArmGlyph({ color = "#3663A8", className = "w-12 h-12" }) {
  return (
    <svg viewBox="0 0 48 48" className={className} xmlns="http://www.w3.org/2000/svg" aria-hidden>
      <circle cx="24" cy="24" r="22" fill={color} fillOpacity="0.10" />
      <circle cx="24" cy="24" r="14" fill={color} fillOpacity="0.22" />
      <circle cx="24" cy="24" r="6" fill={color} />
    </svg>
  );
}

/**
 * LetterSigil — uses cropped letterforms from the official logo (i, y, a, f).
 * Floats decoratively in section backgrounds at low opacity.
 */
export function LetterSigil({ letter = "i", className = "", opacity = 0.08, rotate = 0 }) {
  return (
    <img
      src={asset(`/assets/logos/letter-${letter}.png`)}
      alt=""
      aria-hidden
      className={`pointer-events-none select-none ${className}`}
      style={{ opacity, transform: `rotate(${rotate}deg)`, objectFit: "contain" }}
      draggable={false}
    />
  );
}

/** Legacy alias */
export const IyafMark = IyafMonogram;
